import { typography } from "@shared/common/Themes/typography.ts";

let measureContext: CanvasRenderingContext2D | null | undefined;

const getMeasureContext = () => {
  if (measureContext === undefined)
    measureContext = document.createElement("canvas").getContext("2d");
  return measureContext;
};

export const getTextWidth = (
  text: string | undefined,
  fontSize: number,
  fontWeight: number,
  fontFamily: string = typography.fontFamily
) => {
  const context = getMeasureContext();
  if (!context || !text) return 0;
  context.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  return context.measureText(text).width;
};
